import { apiClient } from './apiClient';

export interface Child {
  id: string;
  name: string;
  birthday?: string;
  createdAt: string;
}

export interface Vaccination {
  id: string;
  name: string;
  date: string;
  doctor?: string;
}

/**
 * Получить всех детей
 */
export async function getChildren(): Promise<{ children: Child[] }> {
  return apiClient.get('/webapp/children/');
}

/**
 * Добавить ребёнка
 */
export async function addChild(data: Omit<Child, 'id' | 'createdAt'>): Promise<{ child: Child }> {
  return apiClient.post('/webapp/children/', data);
}

/**
 * Обновить данные ребёнка
 */
export async function updateChild(id: string, data: Partial<Child>): Promise<{ child: Child }> {
  return apiClient.put(`/webapp/children/${id}`, data);
}

/**
 * Удалить ребёнка
 */
export async function deleteChild(id: string): Promise<{ success: boolean }> {
  return apiClient.delete(`/webapp/children/${id}`);
}

// ============ Surveys (Опросы с бонусами) ============
export interface Survey {
  id: string;
  title: string;
  description?: string;
  rewardPoints?: number;
  isActive: boolean;
  createdAt: string;
}

export interface SurveyDetails {
  id: string;
  title: string;
  description?: string;
  rewardPoints?: number;
  questions: SurveyQuestion[];
}

export interface SurveyQuestion {
  id: string;
  text: string;
  type: 'text' | 'single_choice' | 'multiple_choice' | 'rating';
  options?: string[];
  order: number;
}

/**
 * Получить доступные опросы
 */
export async function getSurveys(): Promise<{ surveys: Survey[] }> {
  return apiClient.get('/webapp/surveys/');
}

/**
 * Получить опрос с вопросами
 */
export async function getSurvey(surveyId: string): Promise<{ survey: SurveyDetails; alreadyCompleted: boolean }> {
  return apiClient.get(`/webapp/surveys/${surveyId}`);
}

/**
 * Сохранить ответ на вопрос
 */
export async function saveSurveyAnswer(surveyId: string, questionId: string, answers: string[]): Promise<{ success: boolean }> {
  return apiClient.post(`/webapp/surveys/${surveyId}/answer`, {
    questionId,
    answers,
  });
}

/**
 * Завершить опрос и получить бонусы
 */
export async function completeSurvey(surveyId: string): Promise<{ success: boolean; message: string }> {
  return apiClient.post(`/webapp/surveys/${surveyId}/complete`);
}

